module.exports = __webpack_public_path__ + "img/cursor-big.e049b9eb.svg";